import { Type } from '../services/types'

const trunc = new Map<Type, number>()

trunc.set(Type.CO2, 0)
trunc.set(Type.Temperature, 1)
trunc.set(Type.Humidity, 0)

export default trunc
